import CustomFileInputSecondary from "@/components/Form/InputFields/CustomFileInputSecondary";
import SpacingGrid from "@/components/Grid/SpacingGrid";
import { useWatch } from "react-hook-form";
import { ListTypeModuleCommonProps } from "../../beeswaxList.interface";

// Shared by the App Bundle and App ID list types — both are a plain one-item-per-line
// CSV/TXT upload, identical to the Domain/Deal/Zip modules.
export default function AppList({
  control,
  id,
  onUploadListItem,
  isUploadingListItem,
  subText,
  isActive,
  inActiveText,
}: ListTypeModuleCommonProps) {
  const file = useWatch({ control, name: "listItemFile" });

  function onUploadFile() {
    onUploadListItem(file, id);
  }

  return (
    <SpacingGrid itemContainer spacingType="form">
      <SpacingGrid item>
        <CustomFileInputSecondary
          control={control}
          name="listItemFile"
          handleUpload={onUploadFile}
          label="Upload File"
          disabled={isUploadingListItem || !isActive}
          disableUpload={!file || !isActive}
          subText={subText}
          inputProps={{
            accept: ".csv, .txt",
          }}
          disabledTooltip={!isActive ? inActiveText : undefined}
        />
      </SpacingGrid>
    </SpacingGrid>
  );
}
